if (window.avant.production_env) {
  window.neuroIdScriptUrl = '//scripts.neuro-id.com/c/nid-avantcom-v1.0.js'
} else {
  window.neuroIdScriptUrl = '//scripts.neuro-id.com/c/nid-avantcom-v1.0-stg.js'
}
(function(n,e,u,r,o,i,d){
    n.nid=n.nid||function(){(n.nid.q=n.nid.q||[]).push(arguments)},
    o=e.createElement(u),i=e.getElementsByTagName(u)[0];o.async=1;o.src=r;
    i.parentNode.insertBefore(o,i);
})(window,document,'script',window.neuroIdScriptUrl);
